export default {
    name: 'Name',

    createMailTemplate: 'E-Mailvorlage erstellen',
    createAndEditMailTemplate: 'E-Mailvorlage erstellen und bearbeiten',

    createMailTemplateSuccess: 'E-Mailvorlage erfolgreich erstellt',
    createMailTemplateError: 'Fehler beim Erstellen der E-Mailvorlage',
}